'use client'

import { useEffect, useState } from 'react'
import { isCollectionInSnipeRollout, isSnipeProtectionOffered, type SecureAssetProtocol } from './secure-purchase'

/**
 * Whether listings for `protocol` settle with snipe protection.
 *
 * There is no seller choice: protection is on whenever the API offers it and
 * off, falling back to the standard listing path, whenever it does not. That
 * makes the API flag the single switch for the whole feature. `offered`
 * starts false so nothing protected is shown before the probe resolves.
 */
export function useSnipeProtection(protocol: SecureAssetProtocol, collectionSlug?: string | null) {
	const [apiOffered, setApiOffered] = useState(false)

	useEffect(() => {
		let active = true
		isSnipeProtectionOffered(protocol).then((value) => {
			if (active) setApiOffered(value)
		})
		return () => {
			active = false
		}
	}, [protocol])

	// The API flag is the kill switch; the rollout list is the dial.
	const offered = apiOffered && isCollectionInSnipeRollout(collectionSlug)
	return { offered, enabled: offered }
}
